import Image from "next/image";
import dayjs from "dayjs";
import clsx from "clsx";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { IPost } from "@/types/post";

export const HeroPost: React.FC<{ entry: IPost }> = ({
  entry,
}: {
  entry: IPost;
}) => {
  return (
    <div className="grid grid-cols-12 w-full bg-white">
      <div className="col-span-12 xl:col-span-4 ">
        <div className="">
          <div className="bg-brand-red bg-line-pattern bg-cover text-white h-full p-6 xl:p-16 xl:pb-44 space-y-5 xl:space-y-8 _translate-y-10">
            {entry.contentfulMetadata.tags.length > 0 && (
              <div className="flex">
                <p className="border-2 border-white px-2 py-1.5 text-xs font-bold tracking-widest uppercase">
                  {entry.contentfulMetadata.tags
                    .map((tag: any) => tag.name)
                    .join(", ")}
                </p>
              </div>
            )}
            <h1
              className={clsx(
                " font-bold",
                entry.title.length <= 35
                  ? `text-3xl xl:text-5xl`
                  : entry.title.length <= 45
                  ? `text-2xl xl:text-4xl`
                  : `text-xl xl:text-3xl`
              )}
              {...ContentfulLivePreview.getProps({
                entryId: entry.sys.id,
                fieldId: "title",
              })}
            >
              {entry.title}
            </h1>
          </div>
        </div>
      </div>
      <div className="col-span-12 xl:col-span-8 xl:border-l">
        <div className="w-full xl:w-[calc(100%+1px)] xl:-ml-[1px] h-[350px] xl:h-auto">
          {entry.image?.url && (
            <>
              <Image
                {...ContentfulLivePreview.getProps({
                  entryId: entry.sys.id,
                  fieldId: "image",
                })}
                src={`${entry.image.url}?w=700&h=700&fit=fill`}
                sizes="100vw"
                alt={entry.image.title}
                width={700}
                height={700}
                className="xl:hidden w-full h-full object-cover"
              />
              <Image
                {...ContentfulLivePreview.getProps({
                  entryId: entry.sys.id,
                  fieldId: "image",
                })}
                src={`${entry.image.url}?w=1280&h=720&fit=fill`}
                sizes="100vw"
                alt={entry.image.title}
                width={1280}
                height={400}
                className="hidden xl:block w-full h-full object-cover"
              />
            </>
          )}
        </div>

        <div className="xl:block">
          <div className="shadow-lg bg-white p-6 xl:p-16 xl:-translate-x-24 xl:-translate-y-24 space-y-6 relative z-10 bg-line-pattern bg-repeat bg-[length:420px_420px]">
            {entry.intro && (
              <p
                {...ContentfulLivePreview.getProps({
                  entryId: entry.sys.id,
                  fieldId: "intro",
                })}
                className="text-2xl text-brand-blue"
              >
                {entry.intro}
              </p>
            )}
            <div className="flex">
              <div className="h-1 bg-brand-red w-14" />
            </div>
            {entry.sys.publishedAt && (
              <p className="text-sm text-gray-600">
                Mise à jour le{" "}
                {dayjs(entry.sys.publishedAt).format(`DD/MM/YYYY`)}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
